import React, { useState } from 'react'
import InputCustom from 'components/Inputs'
import { Col, Row } from 'reactstrap'
import useRedux from 'hooks/useRedux'
import CustomSelect from 'components/Select'
import { SimpleTitleCard } from 'styles/global'
import { FiGlobe } from 'react-icons/fi'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'store'
import { maskMoney, maskNumber } from 'util/masks'
import ModalExclusao from 'components/ModalExclusao'
import { DADOS_COMPLEMENTARES_DADOS_BANCARIOS } from 'store/modules/cadastros/dadosComplementaresDadosBancarios/types'
import * as dadosComplementaresDadosBancariosActions from 'store/modules/cadastros/dadosComplementaresDadosBancarios/actions'
import { capitalizeWords } from 'util/textFormatters'

interface InssProps {
  index: number
}

const Inss = ({ index }: InssProps) => {
  const { formulario, invalidFormulario, optionsSelects, loadingSelects } =
    useSelector<ApplicationState, DADOS_COMPLEMENTARES_DADOS_BANCARIOS>(
      (state) => state.dadosComplementaresDadosBancarios
    )

  const { dispatch } = useRedux()

  const [show, setShow] = useState(false)
  const [bancoDisable, setBancoDisable] = useState(false)

  type MatriculaField =
    keyof DADOS_COMPLEMENTARES_DADOS_BANCARIOS['formulario']['dadosBancarios'][number]
  const onChange = <T extends MatriculaField>(
    value: T extends keyof DADOS_COMPLEMENTARES_DADOS_BANCARIOS['formulario']['dadosBancarios'][number]
      ? DADOS_COMPLEMENTARES_DADOS_BANCARIOS['formulario']['dadosBancarios'][number][T]
      : never,
    field: T,
    matriculaIndex: number
  ) => {
    const dadosBancarios = [...(formulario.dadosBancarios || [])]
    if (field === 'tipoContaId') {
      const isOrdemPagamento = optionsSelects.tiposConta?.some(
        (x) => x.value === value && x.descricao === 'ORDEM DE PAGAMENTO'
      )
      const isContaBmg = optionsSelects.tiposConta?.some(
        (x) => x.value === value && x.descricao === 'CONTA BMG'
      )
      setBancoDisable(isOrdemPagamento || isContaBmg)
      if (isOrdemPagamento) {
        const banco = optionsSelects.bancos?.find(
          (x) => x.codigoBanco === '341'
        )
        dadosBancarios[matriculaIndex] = {
          ...dadosBancarios[matriculaIndex],
          bancoDadosBancariosId: banco?.id || ''
        }
      }
      if (isContaBmg) {
        const banco = optionsSelects.bancos?.find(
          (x) => x.codigoBanco === '318'
        )
        dadosBancarios[matriculaIndex] = {
          ...dadosBancarios[matriculaIndex],
          bancoDadosBancariosId: banco?.id || ''
        }
      }
    }
    dadosBancarios[matriculaIndex] = {
      ...dadosBancarios[matriculaIndex],
      [field]: value
    }
    dispatch(
      dadosComplementaresDadosBancariosActions.setFormularioField(
        dadosBancarios,
        'dadosBancarios'
      )
    )
  }

  return (
    <div className="d-flex flex-column row-gap-15">
      <div className="container-fluid">
        <Row>
          <Col md={4}>
            <label className="label-12">Perfil*</label>
            <CustomSelect
              options={optionsSelects.perfis.map((perfil) => {
                return {
                  ...perfil,
                  descricao: capitalizeWords(perfil.descricao)
                }
              })}
              placeholder="Selecione"
              onChange={(e) => {
                onChange(e, 'tipoPerfilId', index)
              }}
              value={formulario.dadosBancarios[index]?.tipoPerfilId}
              accessorLabel="descricao"
              accessorValue="id"
              invalid={
                invalidFormulario.dadosBancarios[index]?.tipoPerfilId.invalid
              }
              errorMessage={
                invalidFormulario.dadosBancarios[index]?.tipoPerfilId.message
              }
              disabled
              isLoading={loadingSelects.perfis}
            />
          </Col>
          <Col md={3}>
            <label className="label-12">Matrícula/Benefício*</label>
            <InputCustom
              name="matricula"
              type="text"
              onChange={(e) => {
                onChange(e.target.value, 'numeroMatricula', index)
              }}
              placeholder="Digite aqui"
              value={formulario.dadosBancarios[index]?.numeroMatricula || ''}
              invalid={
                invalidFormulario.dadosBancarios[index]?.numeroMatricula
                  ?.invalid
              }
              disabled
              errorMessage={
                invalidFormulario.dadosBancarios[index]?.numeroMatricula
                  ?.message
              }
              maxLength={15}
            />
          </Col>
          <Col md={3}>
            <label className="label-12">Salário*</label>
            <InputCustom
              name="matricula"
              type="text"
              onChange={(e) => {
                onChange(
                  maskMoney(e.target.value),
                  'valorRendaIndividual',
                  index
                )
              }}
              placeholder="Digite aqui"
              value={
                formulario.dadosBancarios[index]?.valorRendaIndividual || ''
              }
              invalid={
                invalidFormulario.dadosBancarios[index]?.valorRendaIndividual
                  ?.invalid
              }
              disabled
              errorMessage={
                invalidFormulario.dadosBancarios[index]?.valorRendaIndividual
                  ?.message
              }
              maxLength={15}
            />
          </Col>
        </Row>
      </div>
      <div className="container-fluid">
        <SimpleTitleCard>
          <FiGlobe className="icon" /> Dados bancários
        </SimpleTitleCard>
        <Row>
          <Col md={4}>
            <label className="label-12">Tipo conta*</label>
            <CustomSelect
              options={optionsSelects.tiposConta}
              placeholder="Selecione"
              onChange={(e) => {
                onChange(e, 'tipoContaId', index)
              }}
              value={formulario.dadosBancarios[index]?.tipoContaId}
              accessorLabel="descricao"
              accessorValue="value"
              invalid={
                invalidFormulario.dadosBancarios[index]?.tipoContaId.invalid
              }
              errorMessage={
                invalidFormulario.dadosBancarios[index]?.tipoContaId.message
              }
              isLoading={loadingSelects.tiposConta}
            />
          </Col>
          <Col md={4}>
            <label className="label-12">Banco*</label>
            <CustomSelect
              options={optionsSelects.bancos}
              placeholder="Selecione"
              onChange={(e) => {
                onChange(e, 'bancoDadosBancariosId', index)
              }}
              value={formulario.dadosBancarios[index]?.bancoDadosBancariosId}
              accessorLabel="descricao"
              accessorValue="id"
              invalid={
                invalidFormulario.dadosBancarios[index]?.bancoDadosBancariosId
                  .invalid
              }
              errorMessage={
                invalidFormulario.dadosBancarios[index]?.bancoDadosBancariosId
                  .message
              }
              disabled={bancoDisable}
              isLoading={loadingSelects.bancos}
            />
          </Col>
          <Col md={4}>
            <label className="label-12">Agência*</label>
            <InputCustom
              type="text"
              placeholder="Digite aqui"
              onChange={(e) => {
                onChange(maskNumber(e.target.value), 'agencia', index)
              }}
              value={formulario.dadosBancarios[index]?.agencia || ''}
              invalid={invalidFormulario.dadosBancarios[index]?.agencia.invalid}
              errorMessage={
                invalidFormulario.dadosBancarios[index]?.agencia.message
              }
              maxLength={10}
            />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <label className="label-12">Dígito agência</label>
            <InputCustom
              type="text"
              placeholder="Digite aqui"
              onChange={(e) => {
                onChange(maskNumber(e.target.value), 'digitoAgencia', index)
              }}
              value={formulario.dadosBancarios[index]?.digitoAgencia || ''}
              invalid={
                invalidFormulario.dadosBancarios[index]?.digitoAgencia?.invalid
              }
              errorMessage={
                invalidFormulario.dadosBancarios[index]?.digitoAgencia?.message
              }
              maxLength={1}
            />
          </Col>
          <Col md={4}>
            <label className="label-12">Número conta*</label>
            <InputCustom
              type="text"
              placeholder="Digite aqui"
              onChange={(e) => {
                onChange(maskNumber(e.target.value), 'numeroConta', index)
              }}
              value={formulario.dadosBancarios[index]?.numeroConta || ''}
              invalid={
                invalidFormulario.dadosBancarios[index]?.numeroConta.invalid
              }
              errorMessage={
                invalidFormulario.dadosBancarios[index]?.numeroConta.message
              }
              maxLength={10}
            />
          </Col>
          <Col md={4}>
            <label className="label-12">Dígito conta*</label>
            <InputCustom
              type="text"
              placeholder="Digite aqui"
              onChange={(e) => {
                onChange(maskNumber(e.target.value), 'digitoConta', index)
              }}
              value={formulario.dadosBancarios[index]?.digitoConta || ''}
              invalid={
                invalidFormulario.dadosBancarios[index]?.digitoConta.invalid
              }
              errorMessage={
                invalidFormulario.dadosBancarios[index]?.digitoConta.message
              }
              maxLength={1}
            />
          </Col>
        </Row>
      </div>
      {/* <div className="linha-horizontal" /> */}
      {/* <div className="container-fluid">
        <Row>
          <Row>
            <Col className="d-flex justify-content-end">
              <FiTrash className="icon-trash" onClick={() => setShow(true)} />
            </Col>
          </Row>
        </Row>
      </div> */}
      <ModalExclusao
        isOpen={show}
        toggle={(e) => setShow(e)}
        onRemove={() => {
          dispatch(
            dadosComplementaresDadosBancariosActions.removerPerfil(index)
          )
        }}
      />
    </div>
  )
}

export { Inss }
